import React from "react"
import { NavbarOffset } from "./style"

const Offset = () => <NavbarOffset />

export default Offset
